module.exports = __webpack_public_path__ + "img/stu2.6f2d1590.jpeg";